
/**
 *  02/04/2019 v 1.0 - JuanMa
 **/

import React from 'react'

export const prepararChildren= (elemento, children, enTabSeleccionado) => {

    /*
    console.log("PREPARARCHILDREN");
    console.log(elemento);
    console.log("children: ", children);
    console.log(enTabSeleccionado);
    */

    //Si es undefined devolvemos el undefined
    if (!children)
        return children;

    let childrenEnTab= [];
    //Si es un solo elemento comprobamos si debe salir
    if (!Array.isArray(children)){
        let enTab= children.props.enTab;
        if(typeof enTab === 'boolean' && enTab === enTabSeleccionado)
            childrenEnTab.push({...children});
        else
            return null;
    }
    else {
        //Si es un array de elementos, cargamos el array con los hijos que deben salir en tab.
        children.forEach((child) => {
            if (child) {
                //console.log("XXXXX Child: ", child);
                let enTab = child.props.enTab;
                if (typeof enTab === 'boolean' && enTab === enTabSeleccionado) {
                    childrenEnTab.push({...child});
                }
            }
        });
    }

    //Inyectamos el dato
    const childrenWithProps = React.Children.map(childrenEnTab, child =>
        React.cloneElement(child, { dato: elemento})
    );

    //console.log("--> childrenWithProps: ", childrenWithProps);
    return childrenWithProps;
}